import axios from 'axios';
import {token} from '../common/const/token-helper';
import {SERVER} from '../common/const/networkUrls';

const api = axios.create({
    baseURL: SERVER.API_BASE_URL,
    headers: {
        "Content-type": "application/json",
        "Pragma": "no-cache",
        "Cache-Control": "no-cache",
        "csrf": "token",
        "Authorization": `Bearer ${token}`
    }
});

export const authApi = axios.create({
    baseURL: SERVER.API_BASE_URL,
    headers: {
        "Content-type": "application/json",
        "Pragma": "no-cache",
        "Cache-Control": "no-cache"
    }
});

export const videoApi = axios.create({
    baseURL: SERVER.API_BASE_URL,
    responseType: 'blob',
    headers: {
        "Content-Type": "video/mp4",
        "Pragma": "no-cache",
        "Cache-Control": "no-cache",
        "csrf": "token",
        "Authorization": `Bearer ${token}`
      }
});

export default api;
